import React, { useState } from 'react';

import { Box } from '@mantine/core';
import { NavigationControls } from 'pages/PdfViewer/NavigationControls';
import { PdfDocument } from 'pages/PdfViewer/PdfDocument';
import { pdfjs } from 'react-pdf';

// This sets global worker path to worker bundle.
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface PdfViewerProps {
  fileData: ArrayBuffer;
  displayPageWidth: number;
}

export function PdfViewer({ fileData, displayPageWidth }: PdfViewerProps) {
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const onDocumentLoadSuccess = (numPages: number) => {
    setNumPages(numPages);
  };

  const handlePageChange = (newPage: number) => {
    const clampedPage = Math.min(Math.max(newPage, 1), numPages);
    if (clampedPage !== currentPage) setCurrentPage(clampedPage);
  };

  // Preload adjacent pages for better performance
  const getPagesToLoad = () => {
    const pages = [currentPage];

    // Preload more pages (2 before and 2 after) to reduce flickering when navigating
    for (let i = 1; i <= 2; i++) {
      const prevPage = currentPage - i;
      const nextPage = currentPage + i;

      if (prevPage >= 1) pages.push(prevPage);
      if (nextPage <= numPages) pages.push(nextPage);
    }

    return pages;
  };

  return (
    <Box m="0 auto">
      <NavigationControls currentPage={currentPage} numPages={numPages} onPageChange={handlePageChange} />

      <PdfDocument
        fileData={fileData}
        displayPageWidth={displayPageWidth}
        currentPage={currentPage}
        pagesToLoad={getPagesToLoad()}
        onDocumentLoadSuccess={onDocumentLoadSuccess}
      />
    </Box>
  );
}
